"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtensionApi = void 0;
const nodes_1 = require("../model/api/nodes");
class ExtensionApi extends nodes_1.NodeApi {
    /**
     * Attaches a listener which executes on every change that is executed
     * directly on this node. For example, if this is a "str" string node and
     * you insert or delete text, the listener will be executed. Or if
     * this is an "obj" object node and keys of this object are changed, this
     * listener will be executed.
     *
     * It does not trigger when child nodes are edit, to include those changes,
     * use `onSubtreeChange()` or `onChildChange()` methods.
     *
     * @see onChildChange()
     * @see onSubtreeChange()
     *
     * @param listener Callback called on every change that is executed directly
     *     on this node.
     * @returns Returns an unsubscribe function to stop listening to the events.
     */
    onSelfChange(listener) {
        return this.api.wrap(this.node.data).onSelfChange(listener);
    }
    /**
     * Attaches a listener which executes on every change that is applied to this
     * node's children. Hence, this listener will trigger only for *container*
     * nodes - nodes that can have child nodes, such as "obj", "arr", "vec", and
     * "val" nodes. It will not execute on changes made directly to this node.
     *
     * If you want to listen to changes on this node as well as its children, use
     * `onSubtreeChange()` method. If you want to listen to changes on this node
     * only, use `onSelfChange()` method.
     *
     * @see onSelfChange()
     * @see onSubtreeChange()
     *
     * @param listener Callback called on every change that is applied to
     *     children of this node.
     * @return Returns an unsubscribe function to stop listening to the events.
     */
    onChildChange(listener) {
        return this.api.wrap(this.node.data).onChildChange(listener);
    }
    /**
     * Attaches a listener which executes on every change that is applied to this
     * node or any of its child nodes (recursively). This is equivalent to
     * combining both `onSelfChange()` and `onChildChange()` methods.
     *
     * @see onSelfChange()
     * @see onChildChange()
     *
     * @param listener Callback called on every change that is applied to this
     *     node or any of its child nodes.
     * @return Returns an unsubscribe function to stop listening to the events.
     */
    onSubtreeChange(listener) {
        return this.api.wrap(this.node.data).onSubtreeChange(listener);
    }
}
exports.ExtensionApi = ExtensionApi;
